webpackJsonp([258321732320404],{

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SectionPageQuery = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(93);
	
	var _seo = __webpack_require__(53);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _components = __webpack_require__(45);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _linkBack = __webpack_require__(97);
	
	var _linkBack2 = _interopRequireDefault(_linkBack);
	
	var _getContents = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionPage = function SectionPage(_ref) {
	    var data = _ref.data;
	
	    if (!data) {
	        return _react2.default.createElement(
	            'div',
	            null,
	            'section page missing data'
	        );
	    }
	    var page = data.page.edges[0].node;
	    var sectionPages = data.sectionPages.edges;
	    var locations = (0, _getContents.stripNode)(data.locations.edges);
	    var regions = (0, _getContents.stripNode)(data.regions.edges);
	    var certificates = (0, _getContents.stripNode)(data.certificates.edges);
	    //const footer = data.footer.edges[0].node.frontmatter;
	    var seo = {
	        title: '',
	        description: '',
	        image: ''
	    };
	    page.modules.forEach(function (module) {
	        if (module.__typename == 'DatoCmsText') {
	            seo.title = module.title;
	            seo.description = module.body;
	        }
	        if (module.__typename == 'DatoCmsMiniHero') {
	            seo.image = module.image.sizes.src;
	        }
	    });
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_seo2.default, seo),
	        _react2.default.createElement(_components2.default, {
	            content: {
	                __typename: 'submenu',
	                items: (0, _getContents.GetSubmenu)(page.parentPage.slug, sectionPages),
	                backlink: page.parentPage
	            }
	        }),
	        _react2.default.createElement(_linkBack2.default, { parent: page.parentPage }),
	        _react2.default.createElement(
	            'div',
	            { className: 'section indented-contents gray-dividers' },
	            _react2.default.createElement('div', { className: 'mt-60' }),
	            page.modules.map(function (module, i) {
	                return _react2.default.createElement(_components2.default, {
	                    key: i,
	                    content: module,
	                    locations: locations,
	                    regions: regions,
	                    certificates: certificates
	                });
	            })
	        ),
	        _react2.default.createElement(_components2.default, {
	            content: {
	                __typename: 'DatoCmsGiantLinkContainer',
	                links: page.links
	            }
	        })
	    );
	};
	
	exports.default = SectionPage;
	var SectionPageQuery = exports.SectionPageQuery = '** extracted graphql fragment **';
	
	// date(formatString: "MMMM DD, YYYY")

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-section-template-js-af2466813c95b40ff86b.js